import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { colors } from '../utils/colors'
export const AccreditationHorizontalBar = ({ accreditation }) => {
  console.log(accreditation)
  const { t } = useTranslation()
  const keyMapper = {
    [t('employee.other')]: 'employees',
    [t('contract.other')]: 'contracts',
    [t('company.other')]: 'companies',
    [t('asset.other')]: 'assets'
  }

  const options = {
    indexAxis: 'y',
    layout: {
      padding: {
        right: 40
      }
    },
    scales: {
      x: {
        // defining min and max so hiding the dataset does not change scale range
        min: 0,
        max: 100
      }
    },
    elements: {
      bar: {
        borderWidth: 2
      }
    },
    responsive: true,

    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const accreditationKey = keyMapper[context.label]
            const withAccreditation = accreditation[accreditationKey].active
            const totalAccreditation =
              accreditation[accreditationKey].inactive + withAccreditation

            return `${withAccreditation}/${totalAccreditation} ${context.label}`
          }
        }
      }
    }
  }

  const labels = [
    t('company.other'),
    t('contract.other'),
    t('employee.other'),
    t('asset.other')
  ]
  const employeeAccreditationPercentage =
    accreditation.employees?.percentage * 100 ?? 0
  const contractAccreditationPercentage =
    accreditation.contracts?.percentage * 100 ?? 0
  const companyAccreditationPercentage =
    accreditation.companies?.percentage * 100 ?? 0
  const assetAccreditationPercentage =
    accreditation.assets?.percentage * 100 ?? 0

  function getColorByPercentage(percentage) {
    if (percentage === 100) return colors.blue[500]
    if (percentage >= 75) return colors.green[500]
    if (percentage >= 40) return colors.yellow[500]

    return colors.red[500] // Red
  }

  const data = {
    labels,
    datasets: [
      {
        datalabels: {
          color: 'black',
          anchor: 'end',
          align: 'end',
          clamp: false,
          formatter: (value, _context) => {
            if (value >= 1 || value === 0) {
              return `${value.toFixed()}%`
            } else if (value < 1) {
              return `${value.toFixed(1)}%`
            } else {
              return ''
            }
          },
          labels: {
            title: {
              font: {
                size: 12
              }
            }
          }
        },
        data: [
          companyAccreditationPercentage,
          contractAccreditationPercentage,
          employeeAccreditationPercentage,
          assetAccreditationPercentage
        ],
        backgroundColor: [
          getColorByPercentage(companyAccreditationPercentage),
          getColorByPercentage(contractAccreditationPercentage),
          getColorByPercentage(employeeAccreditationPercentage),
          getColorByPercentage(assetAccreditationPercentage)
        ],
        borderWidth: 0,
        borderRadius: 6
      }
    ]
  }
  return <Bar className='h-full' options={options} data={data} />
}
AccreditationHorizontalBar.propTypes = {
  accreditation: PropTypes.object.isRequired
}
